import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Mail, MapPin, Phone, Building, Cookie, Database, Lock, Users, FileText } from 'lucide-react';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, rgba(127, 179, 160, 0.1) 0%, rgba(242, 239, 233, 0.8) 100%)' }}>
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#2A9FCB]/80 hover:text-[#2A9FCB] transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span>Torna alla Home</span>
          </Link>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Title */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Shield className="w-12 h-12 text-[#2A9FCB]" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-[#2A9FCB] mb-2">Privacy Policy e Cookie Policy</h1>
          <p className="text-[#2A9FCB]/80">Informativa ai sensi dell'art. 13 del GDPR 2016/679</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10 space-y-8">
          
          {/* Titolare del Trattamento */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Building className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Titolare del Trattamento</h2>
            </div>
            <div className="bg-[#2A9FCB]/5 rounded-lg p-4 space-y-2">
              <p className="font-semibold text-[#2A9FCB]">PRIME VISION S.R.L.</p>
              <p className="flex items-center gap-2 text-[#2A9FCB]/80">
                <MapPin className="w-4 h-4" /> Via Santa Sofia 10
              </p>
              <p className="flex items-center gap-2 text-[#2A9FCB]/80">
                <Mail className="w-4 h-4" /> PEC: primevision@pec.it
              </p>
              <p className="flex items-center gap-2 text-[#2A9FCB]/80">
                <Mail className="w-4 h-4" /> Email privacy: privacy@primevision.it
              </p>
            </div>
          </section>

          {/* Dati di contatto del DPO */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Users className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Dati di Contatto del DPO</h2>
            </div>
            <p className="text-[#2A9FCB]">
              Per qualsiasi richiesta relativa alla protezione dei dati personali, è possibile contattare il Data Protection Officer (DPO) scrivendo a: <strong>privacy@primevision.it</strong>
            </p>
          </section>

          {/* Finalità del Trattamento */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Database className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Finalità del Trattamento</h2>
            </div>
            
            <div className="space-y-6">
              {/* Funzionamento Sito */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">1. Funzionamento del Sito Web</h3>
                <p className="text-[#2A9FCB] mb-2">
                  La raccolta dei dati e delle informazioni avviene al fine di permettere il corretto funzionamento e la fruizione del sito internet del Titolare (dati di funzionamento, dati statistici, informazioni di sicurezza ecc.). La raccolta dei dati avviene in modo automatico all'apertura delle pagine del sito web.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: legittimo interesse del Titolare del trattamento</p>
              </div>

              {/* Pagamenti */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">2. Gestione dei Pagamenti</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Le operazioni di acquisto tramite le pagine web della Prime Vision sono protette dai servizi di sicurezza (es. Protocollo HTTPS). I servizi di gestione dei pagamenti permettono al Titolare di processare pagamenti tramite carte di credito/carte di debito sul conto bancario, Scalapay, PayPal, Google Pay, Apple Pay ecc.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  I dati utilizzati per il pagamento sono acquisiti direttamente dal gestore del servizio di pagamento richiesto, senza essere trattati dal Titolare, se non per l'esito della transazione.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Alcuni di questi servizi potrebbero, inoltre, prevedere l'invio programmato di messaggi all'Utente, come email contenenti fatture o notifiche riguardanti il pagamento.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Il conferimento dei dati è necessario per poter fornire il servizio richiesto. I dati saranno conservati per <strong>10 anni</strong> in osservanza alla normativa sulla conservazione dei documenti per fini fiscali e contrattuali.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: adempimento ad obblighi contrattuali</p>
              </div>

              {/* Richieste informazioni */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">3. Ricezione delle Richieste di Informazioni e Consulenze</h3>
                <p className="text-[#2A9FCB] mb-2">
                  La raccolta di dati (nome e cognome, recapito telefonico, recapito email, foto, preferenze, residenza) sarà effettuata al fine di evadere richieste di contatto, di interazione, di consulenza sui prodotti e per monitorare i progressi ottenuti.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  I dati sono inviati mediante i form presenti sulla pagina web e possono essere cancellati in ogni momento direttamente dalla sezione "utente". I dati "particolari" (idonei a rivelare lo stato di salute dell'interessato) saranno trattati per diagnosi e suggerimento di specifici protocolli (art. 9 GDPR 2016/679).
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Per la gestione delle richieste potrebbe essere utilizzato un applicativo esterno al sito (es. WhatsApp), in quel caso, i dati potranno essere conosciuti dal gestore dell'applicativo che potrebbe trattarli come autonomo Titolare del trattamento. Prime Vision segnala l'uso di applicativi esterni prima della condivisione dei dati.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Il conferimento dei dati è facoltativo. I dati saranno conservati per il tempo necessario alla gestione della richiesta.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: esercizio di attività contrattuali e pre-contrattuali su richiesta dell'interessato</p>
              </div>

              {/* Prenotazione appuntamenti */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">4. Prenotazione Appuntamenti</h3>
                <p className="text-[#2A9FCB] mb-2">
                  I dati sono trattati per chiedere e gestire un appuntamento con i nostri Medici. Sono trattati esclusivamente dati di contatto.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Il conferimento dei dati è facoltativo. I dati saranno conservati per il tempo necessario alla gestione della richiesta.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: esercizio di attività contrattuali e pre-contrattuali su richiesta dell'interessato</p>
              </div>

              {/* Concorsi */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">5. Partecipazione ad Iniziative (Concorsi a Premi e/o Raccolte Punti)</h3>
                <p className="text-[#2A9FCB] mb-2">
                  I suoi dati saranno trattati per gestire la sua partecipazione a concorsi a premi e/o raccolte punti indette dal Titolare del trattamento. Il conferimento dei dati è facoltativo, tuttavia la mancata raccolta dei dati comporta l'impossibilità a partecipare alle suddette iniziative.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  I dati saranno conservati per il tempo necessario alla gestione dell'evento. Saranno conservati per <strong>10 anni</strong> i soli dati necessari per adempimento a obblighi di Legge.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: esercizio di attività contrattuali e pre-contrattuali su richiesta dell'interessato e adempimento ad obblighi di Legge</p>
              </div>

              {/* Account Prime Vision */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">6. Creazione di un Account Prime Vision</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Tramite il sito è possibile iscriversi alla Community "Prime Vision" creando un account personale.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  La Community ha scopo commerciale, l'iscrizione, infatti, permette di accedere alla dashboard con le proprie informazioni personali, dove trova anche la tessera Prime Vision e può trovare anche la cartella clinica con la propria anamnesi una volta compilata.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  L'iscrizione come account di Prime Vision presuppone il rilascio del consenso alle attività di Marketing del Titolare, in modo da poter usufruire delle offerte dedicate ai partecipanti alla Community.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  I dati saranno conservati fino a richiesta di cancellazione dell'account. Successivamente, saranno conservati i soli dati necessari ad adempiere agli obblighi di Legge.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: adempimento ad obblighi contrattuali (Adesione a Termini e Condizioni) e consenso</p>
              </div>

              {/* NUOVO: Sicurezza Dati Sanitari */}
              <div className="border-l-4 border-green-500 pl-4 bg-green-50/50 p-4 rounded-r-lg">
                <h3 className="font-semibold text-green-700 mb-2">🛡️ 6bis. Sicurezza dei Dati Sanitari</h3>
                <p className="text-[#2A9FCB] mb-3">
                  In quanto struttura sanitaria, PRIME VISION adotta misure di sicurezza rafforzate per la protezione dei dati sanitari, in conformità all'Art. 9 del GDPR e alle normative italiane in materia di sanità digitale.
                </p>
                
                <div className="space-y-3 text-sm">
                  <div className="flex items-start gap-2">
                    <span className="text-green-600 mt-0.5">✓</span>
                    <p className="text-[#2A9FCB]"><strong>Crittografia AES-256:</strong> Tutti i dati sensibili (diagnosi, anamnesi, codice fiscale, referti) sono crittografati a riposo con algoritmo AES-256 (Fernet encryption).</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-green-600 mt-0.5">✓</span>
                    <p className="text-[#2A9FCB]"><strong>Trasmissione sicura:</strong> Tutte le comunicazioni avvengono tramite connessione HTTPS con certificato SSL/TLS.</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-green-600 mt-0.5">✓</span>
                    <p className="text-[#2A9FCB]"><strong>Audit Log:</strong> Ogni accesso ai dati sanitari viene registrato in un log di controllo conforme alle normative.</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-green-600 mt-0.5">✓</span>
                    <p className="text-[#2A9FCB]"><strong>Backup automatici:</strong> I dati sono sottoposti a backup giornalieri crittografati per garantire la continuità operativa.</p>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-green-600 mt-0.5">✓</span>
                    <p className="text-[#2A9FCB]"><strong>Conservazione:</strong> I dati sanitari sono conservati per il periodo previsto dalla legge (10 anni dalla data dell'ultima prestazione).</p>
                  </div>
                </div>
                
                <div className="mt-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
                  <p className="text-xs text-amber-800">
                    <strong>⚠️ Nota FSE:</strong> L'invio automatico dei referti al Fascicolo Sanitario Elettronico (FSE) regionale richiede l'accreditamento della struttura presso il Sistema Sanitario Regionale. Per maggiori informazioni, contattare la segreteria.
                  </p>
                </div>
                
                <p className="text-sm text-green-700 font-medium mt-3">Base giuridica: Art. 9 par. 2 lett. h) GDPR - Trattamento necessario per finalità di medicina preventiva e diagnosi</p>
              </div>

              {/* Customer Experience */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">7. Customer Experience</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Il Titolare potrebbe contattare il Cliente a mezzo email o telefono, per raccogliere informazioni circa la qualità del servizio offerto. Tali attività di trattamento sono finalizzate a migliorare i prodotti e servizi oggetto del contratto e adeguare l'offerta alle esigenze della clientela.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Il conferimento dei dati è facoltativo. I dati saranno conservati per <strong>36 mesi</strong> e, successivamente, archiviati in forma anonima per motivi di statistica e controllo della qualità del servizio.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: legittimo interesse del Titolare del trattamento</p>
              </div>

              {/* Google Forms */}
              <div className="border-l-4 border-[#2A9FCB] pl-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">8. Google Forms (Moduli)</h3>
                <p className="text-[#2A9FCB] mb-2">
                  I dati personali sono raccolti mediante i moduli predisposti da Google (Google Moduli o Google Forms) e trattati al fine di perfezionare i rapporti di collaborazione e commerciali con l'interessato. I dati saranno conservati fino a revoca del consenso.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Il Responsabile del trattamento è Google Ireland Limited ("Google") e il trasferimento dei dati Extra UE legittimato dal Privacy Shield al quale il fornitore aderisce.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Maggiori informazioni su come Google tratta i dati possono essere consultate al seguente link: <a href="https://policies.google.com/privacy/update" target="_blank" rel="noopener noreferrer" className="text-[#2A9FCB] hover:underline">https://policies.google.com/privacy/update</a>
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Sarà sempre possibile revocare il consenso, inviando una comunicazione ai recapiti indicati alla voce Titolare del presente documento.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: consenso</p>
              </div>
            </div>
          </section>

          {/* Marketing */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Mail className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Marketing</h2>
            </div>
            
            <p className="text-[#2A9FCB] mb-4">
              I dati sono trattati per la comunicazione di informazioni di natura commerciale (marketing). Le attività di marketing che il Titolare può porre in essere sono le seguenti:
            </p>

            <div className="space-y-4">
              <div className="bg-[#2A9FCB]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">A) Marketing del Titolare</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Il Titolare del trattamento, potrà inviare comunicazioni pubblicitarie a mezzo email, WhatsApp, SMS, app di messaggistica, servizio postale, social network, newsletter, se saranno forniti i rispettivi dati (indirizzo email, recapito telefonico, indirizzo di residenza/domicilio, ecc).
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  Il Marketing del Titolare è un trattamento facoltativo, eseguito previa raccolta di preventivo consenso. I dati saranno conservati fino a revoca del consenso.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: consenso</p>
              </div>

              <div className="bg-[#2A9FCB]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">B) Marketing di Terze Parti</h3>
                <p className="text-[#2A9FCB]">
                  Il Titolare potrà trasmettere i dati dell'interessato a soggetti terzi per autonome attività di Marketing.
                </p>
              </div>

              <div className="bg-[#2A9FCB]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">C) Soft Spam</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Il Titolare potrà inviare comunicazioni a mezzo email, o servizio postale ai clienti per pubblicizzare prodotti o servizi analoghi a quelli già precedentemente acquistati.
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  È sempre possibile opporsi al trattamento inviando una comunicazione a <strong>privacy@primevision.it</strong>
                </p>
                <p className="text-[#2A9FCB] mb-2">
                  I dati saranno conservati fino a comunicazione di opposizione al trattamento.
                </p>
                <p className="text-sm text-[#2A9FCB] font-medium">Base giuridica: legittimo interesse del Titolare del trattamento ai sensi dell'art. 130 comma 4 del D.Lgs 196/03</p>
              </div>
            </div>
          </section>

          {/* Comunicazione a Terzi */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Users className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Comunicazione Dati a Terzi</h2>
            </div>
            <p className="text-[#2A9FCB] mb-2">
              I dati potranno essere comunicati a terzi per obblighi di Legge. I Suoi dati, inoltre, potranno essere comunicati a società che svolgono, per conto della Prime Vision (Responsabili del trattamento ai sensi dell'art. 28 GDPR), attività di gestione dei sistemi informatici, hosting su server, cloud, contabilità, recupero crediti, rating, ecc.
            </p>
            <p className="text-[#2A9FCB] mb-2">
              Nel perseguimento delle finalità sopra descritte i dati sono comunicati anche a soggetti terzi che possono agire in qualità di autonomi titolari del trattamento, quali istituti bancari incaricati del pagamento, spedizionieri e vettori incaricati delle spedizioni e consegne.
            </p>
            <p className="text-[#2A9FCB]">
              L'elenco di questa tipologia di terzi è disponibile presso i recapiti indicati alla voce Titolare del trattamento. <strong>Non è prevista la diffusione dei dati personali</strong>, a meno di esplicita autorizzazione dell'interessato.
            </p>
          </section>

          {/* Processi Automatizzati */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Lock className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Processi Automatizzati</h2>
            </div>
            <p className="text-[#2A9FCB]">
              Sono previsti processi automatizzati. Alcuni processi prevedono l'ausilio di un operatore, altri l'ausilio di intelligenza artificiale.
            </p>
          </section>

          {/* Trasferimento Extra UE */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <Database className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Trasferimento dei Dati in Paesi Extra UE</h2>
            </div>
            <p className="text-[#2A9FCB] mb-2">
              Le pagine web e relativi applicativi, potrebbero condividere dei dati raccolti con servizi localizzati al di fuori dell'area dell'Unione Europea.
            </p>
            <p className="text-[#2A9FCB]">
              Il Titolare verifica la sussistenza di idonee basi giuridiche per il trasferimento di dati extra UE. Per quanto attiene il trasferimento dati conseguente le attività dei Cookies, si invita a prendere visione della sezione Cookie Policy di seguito riportata.
            </p>
          </section>

          {/* Cookie Policy */}
          <section className="border-t-2 border-[#2A9FCB] pt-8" id="cookie-policy">
            <div className="flex items-center gap-3 mb-4">
              <Cookie className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Cookie Policy</h2>
            </div>
            
            <div className="space-y-4">
              <p className="text-[#2A9FCB]">
                Il presente sito utilizza cookie tecnici e di profilazione. I cookie sono piccoli file di testo che vengono memorizzati sul dispositivo dell'utente quando visita un sito web.
              </p>

              <div className="bg-[#2A9FCB]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">Cookie Tecnici (Necessari)</h3>
                <p className="text-[#2A9FCB]">
                  Questi cookie sono essenziali per il corretto funzionamento del sito web. Non possono essere disabilitati nei nostri sistemi. Solitamente vengono impostati solo in risposta ad azioni compiute dall'utente come la richiesta di servizi (impostazione preferenze privacy, login, compilazione form).
                </p>
              </div>

              <div className="bg-[#2A9FCB]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">Cookie di Profilazione e Analitici</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Questi cookie ci permettono di contare le visite e le fonti di traffico, in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali pagine sono più o meno popolari e a vedere come i visitatori si muovono all'interno del sito.
                </p>
                <p className="text-[#2A9FCB]">
                  Possono essere impostati da noi o da fornitori terzi i cui servizi abbiamo aggiunto alle nostre pagine (es. Google Analytics, Facebook Pixel).
                </p>
              </div>

              <div className="bg-[#2A9FCB]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">Cookie di Marketing</h3>
                <p className="text-[#2A9FCB]">
                  Questi cookie possono essere impostati attraverso il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti.
                </p>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <h3 className="font-semibold text-[#2A9FCB] mb-2">Come Gestire i Cookie</h3>
                <p className="text-[#2A9FCB] mb-2">
                  Puoi gestire le tue preferenze sui cookie in qualsiasi momento cliccando sul banner che appare alla prima visita o modificando le impostazioni del tuo browser.
                </p>
                <p className="text-[#2A9FCB]">
                  La disabilitazione di alcuni cookie potrebbe limitare la tua esperienza di navigazione sul sito.
                </p>
              </div>
            </div>
          </section>

          {/* Diritti dell'Interessato */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <FileText className="w-6 h-6 text-[#2A9FCB]" />
              <h2 className="text-xl font-bold text-[#2A9FCB]">Diritti dell'Interessato</h2>
            </div>
            
            <p className="text-[#2A9FCB] mb-4">
              Ai sensi degli artt. 15 – 22 del GDPR, i diritti dell'interessato sono:
            </p>

            <ul className="space-y-2 mb-4">
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">a)</span>
                <span className="text-[#2A9FCB]">Accesso e diritto di copia dei dati;</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">b)</span>
                <span className="text-[#2A9FCB]">Rettifica;</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">c)</span>
                <span className="text-[#2A9FCB]">Cancellazione;</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">d)</span>
                <span className="text-[#2A9FCB]">Limitazione del trattamento;</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">e)</span>
                <span className="text-[#2A9FCB]">Opposizione;</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">f)</span>
                <span className="text-[#2A9FCB]">La ricezione in un formato strutturato, di uso comune e leggibile da dispositivo automatico e di trasmettere senza impedimenti tali dati a un altro titolare del trattamento; ove tecnicamente fattibile;</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#2A9FCB] font-bold">g)</span>
                <span className="text-[#2A9FCB]">Revoca del consenso.</span>
              </li>
            </ul>

            <p className="text-[#2A9FCB] mb-4">
              L'interessato ha altresì il diritto di non essere sottoposto a una decisione basata unicamente sul trattamento automatizzato.
            </p>

            <div className="bg-[#2A9FCB]/10 rounded-lg p-4">
              <p className="text-[#2A9FCB] mb-2">
                Per avere maggiori informazioni sul trattamento ed esercitare i diritti sopra elencati, si potrà inviare una comunicazione all'indirizzo email:
              </p>
              <p className="font-semibold text-[#2A9FCB]">privacy@primevision.it</p>
            </div>

            <p className="text-[#2A9FCB] mt-4">
              In caso di violazione nel trattamento dei dati personali, l'interessato potrà presentare reclamo al Titolare del trattamento, all'Autorità Garante per la Protezione dei dati o alla competente Autorità Giuridica.
            </p>
            <p className="text-[#2A9FCB] mt-2">
              È possibile proporre reclamo al <strong>Garante per la Protezione dei Dati Personali</strong>, in caso di violazione dei dati personali.
            </p>
          </section>

          {/* Footer */}
          <div className="border-t pt-6 mt-8">
            <p className="text-sm text-[#2A9FCB]/70 text-center">
              Ultimo aggiornamento: Gennaio 2026
            </p>
          </div>
        </div>

        {/* Back to top */}
        <div className="text-center mt-8">
          <Link 
            to="/auth" 
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#2A9FCB] text-white rounded-lg hover:bg-[#2A9FCB] transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Torna alla Registrazione
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
